'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');

var _helpers = require('./helpers');var _helpers2 = _interopRequireDefault(_helpers);
var _PropertyDetailedFormComponent = require('./PropertyDetailedFormComponent');var _PropertyDetailedFormComponent2 = _interopRequireDefault(_PropertyDetailedFormComponent);
var _messageModal = require('../../redux/modules/messageModal');
var _propertiesAnalytics = require('../../redux/modules/propertiesAnalytics');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _propertyDetailedForm = require('../../redux/modules/propertyDetailedForm');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}




var mapStateToProps = function mapStateToProps(state) {
  var address = (0, _helpers2.default)(state.propertyDetails, state.lang.locale);
  return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    propertyDetailedForm: state.propertyDetailedForm,
    propertyDetails: state.propertyDetails,
    isMessageModalOpen: state.messageModal.isMessageModalOpen,
    initialValues: {
      message: '' + (0, _reduxPagan.getLang)(state.lang, 'static')('defaultContactUsForm') } };


};exports.default =

(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  sendPropertyDetailedForm: _propertyDetailedForm.sendPropertyDetailedForm,
  sendPropertyRealtorForm: _propertyDetailedForm.sendPropertyRealtorForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  sendPropertiesAnalytics: _propertiesAnalytics.sendPropertiesAnalytics }),

(0, _reduxForm.reduxForm)({
  form: 'PropertyDetailedContactPublisherForm',
  validate: _validate2.default }))(_PropertyDetailedFormComponent2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertyDetailedContactsUsForm/PropertyDetailedForm.js
// module id = 575
// module chunks = 0